import React, { useEffect, useState } from 'react';
import Notification from '../Notification/Notification'; // Notification importálása
import './ChangePassword.css';

const apiUrl = process.env.REACT_APP_API_URL;

function ChangePassword({ user, handleLogout }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false); // Új állapot a form módosításának nyomon követésére
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');
  const [passwordMatch, setPasswordMatch] = useState(true); // Új állapot az egyezés ellenőrzésére

  useEffect(() => {
    setPasswordMatch(newPassword === confirmPassword);
    if (newPassword !== '' && passwordMatch) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [newPassword, confirmPassword, passwordMatch]);

  const handleCancel = () => {
    handleLogout(0);
  };

  const handleSavePassword = async () => {
    if (!passwordMatch) {
      setNotification({ message: 'A jelszavak nem egyeznek!', type: 'error' });
      return;
    }

    const updatedUser = {
      ...user,  // A meglévő felhasználó összes adata
      password: newPassword,  // Csak a jelszót módosítjuk
    };

    const response = await fetch(`${apiUrl}/changepassword/${user.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(updatedUser),
    });

    if (response.ok) {
      setNotification({ message: 'Jelszó sikeresen módosítva!', type: 'success' });

      // Sikeres jelszómódosítás után átirányítás a login oldalra
      setTimeout(() => {
        handleLogout(1);
      }, 2000); // 2 másodperc késleltetés, hogy a sikeres üzenet megjelenhessen

    } else {
      setNotification({ message: 'Hiba történt a jelszó módosítása során.', type: 'error' });
    }
  };

  return (
    <div className="change-password">
      <h2>Jelszó módosítása</h2>
      <div>
        <label>Új jelszó:</label>
        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
        />
      </div>
      <div>
        <label>Jelszó megerősítése:</label>
        <input
          type="password"
          placeholder="Confirm password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
        />
        {!passwordMatch && (
          <p style={{ color: 'red' }}>A jelszavak nem egyeznek!</p>
        )}
      </div>

      <div className="button-group">
        <button
          onClick={handleSavePassword}
          disabled={!isFormValid} // Ha nincs módosítás, letiltjuk a mentést
          style={{
            backgroundColor: isFormValid ? '#4CAF50' : '#A5D6A7', // Zöld, ha engedélyezett
            color: 'white',
            cursor: isFormValid ? 'pointer' : 'not-allowed'
          }}
        >
          Jelszó mentése
        </button>

        <button
          onClick={handleCancel}
          style={{
            backgroundColor: '#f44336', // Piros gomb
            color: 'white',
            marginLeft: '10px'
          }}
        >
          Mégse
        </button>
      </div>

      {/* Notification komponens */}
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default ChangePassword;
